import {Icon, TextSmallRegular, TextSmallSemiBold} from '@hm/fundamental'
import {mdiFire} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {HotSpot} from '@refra/modules/refra-planning/types'

interface HotspotChartTooltipProps {
  hotspot: HotSpot
}
export const HotspotChartTooltip = ({hotspot}: HotspotChartTooltipProps) => {
  const {t} = useTranslation()

  return (
    <div
      className="bg-gray-900 text-white max-w-96 p-4 rounded-md font-bold"
      data-cy="drillings_tooltip"
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-2">
          <Icon path={mdiFire} className="text-sky-100" />
          <TextSmallSemiBold>{`${t('common.meter')} (${hotspot.meter} m )`}</TextSmallSemiBold>
        </div>
        <TextSmallRegular>{t('refraPlanning.hotspots.hotspotTooltip')}</TextSmallRegular>
      </div>
    </div>
  )
}
